import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/avatar_placeholder.png'


const _withScopeId = n => (_pushScopeId("data-v-44c23a6d"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Main menu")
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_3 = { class: "menu-profile__content" }
const _hoisted_4 = { class: "menu-profile__name ion-no-margin" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Dashboard ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Recommendations ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Profile ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Misc")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Settings ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Write NFC tag ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Terms and conditions")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Imprint")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_avatar = _resolveComponent("ion-avatar")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item_divider = _resolveComponent("ion-item-divider")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_menu = _resolveComponent("ion-menu")!

  return (_openBlock(), _createBlock(_component_ion_menu, {
    side: "start",
    "menu-id": "mainMenu",
    "content-id": "main",
    type: "overlay"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, { color: "primary" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_list, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_item, {
                class: "menu-profile",
                lines: "none"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_avatar, { slot: "start" }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.user.firstName) + " " + _toDisplayString(_ctx.user.lastName), 1)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_item, {
                "router-link": "/tabs/dashboard",
                lines: "full",
                detail: "true",
                "router-direction": "root",
                onClick: _ctx.closeMenu
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_icon, {
                    icon: _ctx.homeOutline,
                    slot: "start"
                  }, null, 8, ["icon"]),
                  _hoisted_5
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_ion_item, {
                "router-link": "/tabs/recommendations",
                lines: "full",
                detail: "true",
                "router-direction": "root",
                onClick: _ctx.closeMenu
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_icon, {
                    icon: _ctx.listOutline,
                    slot: "start"
                  }, null, 8, ["icon"]),
                  _hoisted_6
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_ion_item, {
                "router-link": "/tabs/profile",
                lines: "full",
                detail: "true",
                "router-direction": "root",
                onClick: _ctx.closeMenu
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_icon, {
                    icon: _ctx.personOutline,
                    slot: "start"
                  }, null, 8, ["icon"]),
                  _hoisted_7
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_ion_item_divider, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, null, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_item, { lines: "full" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_icon, {
                    icon: _ctx.settingsOutline,
                    slot: "start"
                  }, null, 8, ["icon"]),
                  _hoisted_9
                ]),
                _: 1
              }),
              _createVNode(_component_ion_item, { lines: "full" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_icon, {
                    icon: _ctx.radioOutline,
                    slot: "start"
                  }, null, 8, ["icon"]),
                  _hoisted_10
                ]),
                _: 1
              }),
              _createVNode(_component_ion_item, { lines: "full" }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              }),
              _createVNode(_component_ion_item, { lines: "full" }, {
                default: _withCtx(() => [
                  _hoisted_12
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}